<ul class="bookmarkActions" *ngIf="isLogged && !isSeller">
  <li class="bookmarkActions__entry">
    <button
      class="bookmarkActions__btn bookmarkActions__btn--wishItem"
      [ngClass]="{'bookmarkActions__btn--follow': isProductWished}"
      (click)="toggleWishedItem()"
    >
      <ng-container *ngIf="isProductWished; else unwish">
        <vc-sprite-icons name="checkmark" class="bookmarkActions__icon bookmarkActions__icon--check"></vc-sprite-icons>
        <ng-container i18n="@@PRODUCT.DETAILS.ACTIONS.DELETE_FROM_WHISLIST">In your WishList</ng-container>
      </ng-container>
      <ng-template #unwish>
        <vc-sprite-icons name="star-line" class="bookmarkActions__icon bookmarkActions__icon--star"></vc-sprite-icons>
        <ng-container i18n="@@PRODUCT.DETAILS.ACTIONS.ADD_WHISLIST">Add to my Wishlist</ng-container>
      </ng-template>
    </button>
  </li>

  <li class="bookmarkActions__entry">
    <button
      class="bookmarkActions__btn bookmarkActions__btn--priceDropAlert"
      [ngClass]="{'bookmarkActions__btn--follow': isPriceDropFollow}"
      (click)="togglePriceDropAlert()"
    >
      <ng-container *ngIf="isPriceDropFollow; else unfollow">
        <vc-sprite-icons name="checkmark" class="bookmarkActions__icon bookmarkActions__icon--check"></vc-sprite-icons>
        <ng-container i18n="@@PRODUCT.DETAILS.ACTIONS.UNFOLLOW_DECREASING_PRICES"
          >You follow price reductions</ng-container
        >
      </ng-container>
      <ng-template #unfollow>
        <img
          class="bookmarkActions__icon bookmarkActions__icon--doubleChevron"
          src="/assets/svg/double-chevron.svg"
          alt=""
        />
        <ng-container i18n="@@PRODUCT.DETAILS.ACTIONS.FOLLOW_DECREASING_PRICES">Follow price reductions</ng-container>
      </ng-template>
    </button>
  </li>

  <li class="bookmarkActions__entry">
    <button
      *ngIf="showAlert"
      class="bookmarkActions__btn bookmarkActions__btn--createAlert"
      appOpenAlertPopin
      [configCatalog]=""
      [product]="product"
    >
      <vc-sprite-icons name="bell-full" class="bookmarkActions__icon bookmarkActions__icon--bell"></vc-sprite-icons>
      <span i18n="@@PRODUCT.DETAILS.ACTIONS.CREATE_ALERT">Create an alert</span>
    </button>
  </li>
</ul>
